import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79d655db&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=79d655db&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d655db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d655db')) {
      api.createRecord('79d655db', component.options)
    } else {
      api.reload('79d655db', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=79d655db&scoped=true", function () {
      api.rerender('79d655db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/bi/index.vue"
export default component.exports